var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Editor',{attrs:{"id":_vm.tinymceId,"init":_vm.init,"disabled":_vm.disabled},model:{value:(_vm.myValue),callback:function ($$v) {_vm.myValue=$$v},expression:"myValue"}}),_c('div',{attrs:{"id":"wdpst"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }